import Eev from 'eev';
import { Fx } from '@/audio/audio';
import { hover } from '@/ui/menu-builder';
import { activateScene } from '@/scenes';
import game from '@/model/game';
export const EVENT_BUS = new Eev();

EVENT_BUS.on('MENU_HOVER', ({sprite, mouseOver}) => {
    hover(sprite, mouseOver);
})

EVENT_BUS.on('MENU_CLICK', ({sprite, actionName, actionPayload}) => {
    Fx.click2();
    switch (actionName) {
        case 'NAVIGATE': {
            activateScene(actionPayload.sceneName, actionPayload.payload);
            break;
        }
        case 'SELECT_SONG': {
            game.song = actionPayload;
            activateScene('select-mode');
            break;
        }
        case 'SELECT_FOLDER': {
            activateScene('select-song', actionPayload);
            break;
        }
        case 'SELECT_MODE': {
            game.mode = actionPayload.payload;
            activateScene(game.mode, {
                ...game.song, 
                mode: game.mode
            });
            break;
        }
        case 'RESTART': {
            game.mode = game.lastMode || game.mode;
            game.song = game.lastSong ? game.lastSong : game.song;
            const chart = game.song;
            activateScene(game.mode, {
                ...chart
            });
            break;
        }
        case 'EXIT': {
            window.close();
            break;
        }
        case 'REFRESH': {
            window.location.reload();
            break;
        }
        default: alert(actionName + '\n' + JSON.stringify(actionPayload, null, 2));
    }
    
})

